
import data from "@/mixins/data.js"

export default {
  name: "StepTab3",
  mixins: [data],
}
